module.exports = __webpack_public_path__ + "media/images/number_3_red-5fd9876b135d01d51fa52adb637d46b3.png";